// extracted by mini-css-extract-plugin
export var border = "_1p-7";
export var brand = "_1p-s";
export var button = "_1p-k";
export var center = "_1p-9";
export var centered = "_1p-5";
export var closeButton = "_1p-b";
export var disabledWrapper = "_1p-l";
export var error = "_1p-o";
export var extraLarge = "_1p-4";
export var extraSmall = "_1p-1";
export var fill = "_1p-h";
export var footer = "_1p-g";
export var footerAction = "_1p-i";
export var footerButtons = "_1p-j";
export var header = "_1p-6";
export var headerWithClose = "_1p-c";
export var icon = "_1p-n";
export var info = "_1p-r";
export var inline = "_1p-8";
export var large = "_1p-3";
export var main = "_1p-d";
export var modal = "_1p-0";
export var neutral = "_1p-t";
export var noPadding = "_1p-f";
export var none = "_1p-u";
export var scrollable = "_1p-e";
export var small = "_1p-2";
export var success = "_1p-q";
export var tight = "_1p-m";
export var titleIcon = "_1p-a";
export var warn = "_1p-p";